import API, { handleRequest } from '@/api/lib/api'

export const getRestaurantDevices = (restaurantId, params = {}) => {
  const { page = 1, per_page = 10 } = params
  const query = `?page=${page}&per_page=${per_page}`

  return handleRequest(() =>
    API.get(`restaurant/${restaurantId}/settings/devices${query}`)
  )
}

export const createDevice = payload =>
  handleRequest(() => API.post(`admin/devices`, payload))

export const updateDevice = (deviceId, payload) =>
  handleRequest(() => API.put(`admin/devices/${deviceId}`, payload))

export const deleteDevice = deviceId =>
  handleRequest(() => API.delete(`admin/devices/${deviceId}`))

export const getAllTills = restaurantId =>
  handleRequest(() => API.get(`restaurant/devices/tills`))

export const acceptDevice = deviceId =>
  handleRequest(() => API.put(`admin/devices/${deviceId}/accept`))

export const blockDevice = deviceId =>
  handleRequest(() => API.put(`admin/devices/${deviceId}/block`))

export const unblockDevice = deviceId =>
  handleRequest(() => API.put(`admin/devices/${deviceId}/unblock`))

export const switchDevice = (restaurantId, deviceId, payload) =>
  handleRequest(() =>
    API.put(
      `client_panel/restaurant/${restaurantId}/device/${deviceId}/transfer`,
      payload
    )
  )

export const toggleDeviceStatus = deviceId =>
  handleRequest(() => API.put(`restaurant/settings/devices/${deviceId}/toggle-status`))

export const updatePaymentAlertTime = (deviceId, payment_alert_time) =>
  handleRequest(() =>
    API.put(`restaurant/settings/devices/${deviceId}/payment-alert-time`, {
      payment_alert_time,
    })
  )
